<template>
  <div class="matters-list">

    <div v-for="matter in matters"
         class="matter-list-row"
         @click="matterClick(matter)">
      <v-icon v-if="matter.current_matter">
        icon-v
      </v-icon>
      {{matter.display_name}}
    </div>

  </div>
</template>

<script>
  export default {
    name: "MattersList",
    props: {
      matters: {
        type: Array,
        required: true
      },
      contact: {
        type: Object,
        required: true
      }
    },
    methods: {
      matterClick(matter) {
        if(!matter.current_matter) {
          this.$frontageApi.navigateTo('app.client', {uid: this.contact.uid, matter_uid: matter.uid});
          // this.$frontageApi.send('matter_action', {action: 'set_matter', matter: matter, client: this.contact});
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .matters-list {

    .matter-list-row {
      min-height: 40px;
      max-height: 59px;
      font-size: 14px;
      padding: 10px 0;
      @include i-padding-mirror(40px, 25px);
      margin: 0 -25px;
      cursor: pointer;
      transition: background-color 0.2s;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

      &:hover {
        background-color: $grey-color-10;
      }

      .v-icon {
        font-size: 16px;
        margin-inline-start: -20px;
      }
    }
  }

</style>
